/**
 * Reduz um documento (CPF, CNS, telefone, CEP...) aos seus dígitos.
 *
 * Usar isto para comparar "o valor mudou?" é obrigatório em campos mascarados:
 * o `IMaskInput` normaliza o valor recebido da API no mount e propaga o
 * resultado para o Formik. Um CPF gravado como `12345678901` vira
 * `123.456.789-01` sem o usuário digitar nada, e a comparação literal contra o
 * valor original acusaria uma alteração que não houve.
 */
export const apenasDigitos = (valor?: string | null): string =>
  String(valor ?? '').replace(/\D/g, '')
